import React, {useState, useCallback} from 'react';
import {createHook, createProvider, ProviderProps} from 'utils';

type AppStore = ReturnType<typeof useAppStoreHook>;

function useAppStoreHook() {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = useCallback(() => {
        setSidebarOpen(open => !open);
    }, []);

    return {
        sidebarOpen,
        toggleSidebar,
    };
}

const Context = React.createContext<AppStore | null>(null);

export const AppStoreProvider = (props: ProviderProps) => {
    const value = useAppStoreHook();
    return createProvider(Context, value, props);
};
export const useAppStore = createHook<AppStore>(Context, 'AppStore Store');